import styled from 'styled-components';
import { KOALA } from 'HubStyleTokens/colors';
import withErrorBoundary from '../ErrorBoundary';
import { FEATURE_TABLE } from '../_core/common/constants/ErrorBoundaryNames';
import ExpandableSection from './ExpandableSection';
import FeatureTableHead from './FeatureTableHead';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TableContainer = styled.div.withConfig({
  displayName: "FeatureTable__TableContainer",
  componentId: "u88a0-0"
})(["width:100%;table{width:100%;border-spacing:0;table-layout:fixed;}table thead tr th:nth-child(1),table tbody tr th:nth-child(1){width:", ";border:1px solid ", ";}"], ({
  numColumns
}) => numColumns < 3 ? '50%' : '30%', KOALA);
export const Table = styled.table.withConfig({
  displayName: "FeatureTable__Table",
  componentId: "u88a0-1"
})(["tbody tr{display:table;width:100%;table-layout:fixed;min-height:70px;}"]);
const FeatureTable = ({
  headerData,
  bodyData,
  canViewNewSeats
}) => {
  const numColumns = Object.keys(bodyData.sharedData.levels).length;
  const sections = Object.keys(bodyData.sectionData);
  return /*#__PURE__*/_jsxs(TableContainer, {
    numColumns: numColumns,
    "data-test-id": "feature-table",
    id: "feature-table",
    children: [/*#__PURE__*/_jsx(Table, {
      children: /*#__PURE__*/_jsx(FeatureTableHead, {
        headerData: headerData
      })
    }), /*#__PURE__*/_jsx(Table, {
      children: sections.map(section => {
        return /*#__PURE__*/_jsx(ExpandableSection, {
          featureTableCategory: bodyData.sectionData[section],
          tableSharedData: bodyData.sharedData,
          id: section,
          showLabel: sections.length > 1,
          canViewNewSeats: canViewNewSeats
        }, section);
      })
    })]
  });
};
export default withErrorBoundary(FeatureTable, {
  boundaryName: FEATURE_TABLE
});